import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { DataService } from 'services/data.service';
import { MessageSignLogs } from 'domain-models/MessageSignLogs';
import { environment } from '../../environments/environment';

@Injectable()
export class MessageSignLogsService extends DataService<MessageSignLogs> {
	constructor(http: Http) {
		super(environment.host + 'MessageSignLogs', http);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/messageSignLogs/message-sign-logs.service.ts